import type { ReactNode } from "react";

type DetailItem = {
  label: string;
  value: ReactNode;
};

type ResponsiveDetailGridProps = {
  items: DetailItem[];
  columns?: 1 | 2;
};

export function ResponsiveDetailGrid({
  items,
  columns = 2,
}: ResponsiveDetailGridProps) {
  const visibleItems = items.filter((item) => item.value !== undefined && item.value !== null && item.value !== "");

  if (!visibleItems.length) return null;

  return (
    <div
      className={
        columns === 1
          ? "grid grid-cols-1 gap-3"
          : "grid grid-cols-1 gap-3 sm:grid-cols-2"
      }
    >
      {visibleItems.map((item) => (
        <div key={item.label} className="min-w-0">
          <p className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
            {item.label}
          </p>
          <div className="mt-1 text-sm text-foreground break-words">{item.value}</div>
        </div>
      ))}
    </div>
  );
}
